<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Checkout" subtitle="Checkout"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- coupon-area start -->
  <section class="coupon-area pt-100 pb-30" *ngIf="cartService.getCartProducts().length > 0">
    <div class="container">
      <div class="row">
        <!--<div class="col-md-12">
          <div class="coupon-accordion">
            <h3>Returning customer? <span id="showlogin" (click)="handleOpenLogin()">Click here to login</span></h3>
            <div *ngIf="isOpenLogin" id="checkout-login" class="coupon-content">
              <div class="coupon-info">
                <p class="coupon-text">Quisque gravida turpis sit amet nulla posuere lacinia. Cras sed est
                  sit amet ipsum luctus.</p>
                <form action="#">
                  <p class="form-row-first">
                    <label>Email <span class="required">*</span></label>
                    <input type="text" />
                  </p>
                  <p class="form-row-last">
                    <label>Password <span class="required">*</span></label>
                    <input type="password" />
                  </p>
                  <p class="form-row">
                    <button class="os-btn os-btn-black" type="submit">Login</button>
                    <label>
                      <input type="checkbox" />
                      Remember me
                    </label>
                  </p>
                  <p class="lost-password">
                    <a href="#">Lost your password?</a>
                  </p>
                </form>
              </div>
            </div>

          </div>
        </div>-->
        <!-- <div class="col-md-6">
          <div class="coupon-accordion">
            <h3>Have a coupon? <span id="showcoupon" (click)="handleOpenCoupon()">Click here to enter your code</span>
            </h3>
            <div *ngIf="isOpenCoupon" id="checkout_coupon" class="coupon-checkout-content">
              <div class="coupon-info">
                <form action="#">
                  <p class="checkout-coupon">
                    <input type="text" placeholder="Coupon Code" />
                    <button class="os-btn os-btn-black" type="submit">Apply Coupon</button>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
  <!-- coupon-area end -->

  <!-- checkout-area start -->
  <section class="checkout-area pb-70">
    <div class="container">
      <div *ngIf="cartService.getCartProducts().length === 0;else checkoutBlock" class="text-center pt-80 pb-30">
        <h3 class="py-2">No items found in cart to checkout</h3>
        <a routerLink="/shop" class="os-btn os-btn-black">
          Return to shop
        </a>
      </div>

      <ng-template #checkoutBlock>
        <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit(checkoutForm.value)">
          <div class="row">
            <div class="col-lg-6">
              <div class="checkbox-form">
                <h3>Billing Details</h3>
                <div class="row">
                  <div class="col-md-6">
                    <div class="checkout-form-list">
                      <label>First Name <span class="required">*</span></label>
                      <input type="text" id="firstName" placeholder="" formControlName="first_name" />
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['first_name']?.errors?.['required']" class="text-danger">
                        First Name is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="checkout-form-list">
                      <label>Last Name <span class="required">*</span></label>
                      <input type="text" id="lastName" placeholder="" formControlName="last_name" />
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['last_name']?.errors?.['required']" class="text-danger">
                        Last Name is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="checkout-form-list">
                      <label>Company Name</label>
                      <input type="text" id="company" placeholder="" formControlName="company" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="checkout-form-list">
                      <label>Address <span class="required">*</span></label>
                      <input type="text" id="address" placeholder="Street address" formControlName="address_line1" />
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['address_line1']?.errors?.['required']" class="text-danger">
                        Address is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="checkout-form-list">
                      <input id="apartment" type="text" formControlName="address_line2" placeholder="Apartment, suite, unit etc. (optional)" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="checkout-form-list">
                      <label>City <span class="required">*</span></label>
                      <input type="text" id="city" placeholder="City" formControlName="city"/>
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['city']?.errors?.['required']" class="text-danger">
                        City is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="checkout-form-list">
                      <label>State <span class="required">*</span></label>
                      <input type="text" id="state" placeholder="" formControlName="state" />
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['state']?.errors?.['required']" class="text-danger">
                        State is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="country-select">
                      <label>Country <span class="required">*</span></label>
                      <select formControlName="country">
                        <option value="india">india</option>
                        <!-- <option value="algeria">Algeria</option>
                        <option value="afghanistan">Afghanistan</option>
                        <option value="ghana">Ghana</option>
                        <option value="albania">Albania</option>
                        <option value="bahrain">Bahrain</option>
                        <option value="colombia">Colombia</option>
                        <option value="dominican-republic">Dominican Republic</option> -->
                      </select>
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['country']?.errors?.['required']"
                        class="text-danger">
                        Country is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="checkout-form-list">
                      <label>Postcode<span class="required">*</span></label>
                      <input type="text" id="zipCode" placeholder="Postcode / Zip" formControlName="postcode" />
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['zipCode']?.errors?.['required']" class="text-danger">
                        ZipCode is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="checkout-form-list">
                      <label>Phone <span class="required">*</span></label>
                      <input type="text" placeholder="Phone" id="phone" formControlName="phone" />
                      <!-- error message -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['phone']?.errors?.['required']" class="text-danger">
                        Last Name is required
                      </span>
                      <!-- error message -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="checkout-form-list">
                      <label>Email Address <span class="required">*</span></label>
                      <input type="email" placeholder="" id="email" formControlName="email" readonly/>
                      <!-- error msg start -->
                      <span *ngIf="formSubmitted && checkoutForm.controls?.['email']?.errors?.['required']" class="text-danger" >
                        Email is required and must be a valid email address
                      </span>
                      <!-- error msg end -->
                    </div>
                  </div>
                  <!-- <div class="col-md-12">
                    <div class="checkout-form-list">
                      <label for="password">Password <span class="required">*</span></label>
                      <input type="password" placeholder="" id="password" formControlName="password"/>

                      <span *ngIf="formSubmitted && checkoutForm.controls?.['password']?.errors?.['required']" class="text-danger" >
                        Password is required.
                      </span>
                    </div>
                  </div> -->
                </div>
                <div class="different-address">
                  <div class="order-notes">
                    <div class="checkout-form-list">
                      <label>Order Notes</label>
                      <textarea formControlName="notes" id="checkout-mess" cols="30" rows="10"
                        placeholder="Notes about your order, e.g. special notes for delivery."></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="your-order mb-30 ">
                <h3>Your order</h3>
                <div class="your-order-table table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th class="product-name">Product</th>
                        <th class="product-total">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of cartService.getCartProducts()" class="cart_item">
                        <td class="product-name">
                          {{item.title}} <strong class="product-quantity"> × {{item.orderQuantity}}</strong>
                        </td>
                        <td class="product-total">
                          <span class="amount">₹{{item.sale_price.toFixed(2)}}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="cart-subtotal">
                        <th>Cart Subtotal</th>
                        <td>
                          <span class="amount">₹{{cartService.totalPriceQuantity().total.toFixed(2)}}</span>
                        </td>
                      </tr>
                      <tr class="order-total">
                        <th>Order Total</th>
                        <td><strong><span class="amount">
                          ₹{{(cartService.totalPriceQuantity().total).toFixed(2)}}
                         </span></strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div class="payment-method">
                  <div class="order-button-payment mt-20" *ngIf="tokenStorage.isLogin()">
                    <button type="submit" class="os-btn os-btn-black">Place order</button>
                  </div>
                  <div class="order-button-payment mt-20" *ngIf="!tokenStorage.isLogin()">
                    <button type="button" class="os-btn os-btn-black" routerLink="/login" >Login</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-template>
    </div>
  </section>
  <!-- checkout-area end -->

</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
